module.exports = __webpack_public_path__ + "img/9blue.b86277e8.png";